<template>
  <div class="mainHolder">
        <div id="sec-one">
            <div class="outer">
                <div class="content">
                    <div class="item">
                        <div id="leftPanel">
                            <TopBar/>
                            <div id="mainMenuSelected">SEND MESSAGE</div>
                            <p class="infoOption">Please select a message type:</p>
                            <MainMenu
                                :templates_data="templates_data"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="sec-two" >
            <div class="outer">
                <div class="content">
                    <div class="p15">
                        <Logo className="item pt30 smallMainLogo"/>
                    </div>
                    <div class="bg-three">
                        <form class="schedule-form" @submit.prevent="sendMsgBox">
                            <br><br>
                            <div class="field-form">
                                <textarea v-model.trim="custom_content" id="custom_content" placeholder="Please enter your message here"></textarea>
                            </div>
                            <div class="field-form">
                               <div class="client_number">
                                    <div>
                                        <span>Customer's phone number:</span>
                                    </div>
                                    <div>
                                        <input type="text" placeholder="(000) 000-0000" v-model.trim="phone_number" v-maska="'(###) ### ####'">
                                    </div>
                               </div>
                            </div>
                            <div class="field-formx">
                                <button
                                    class="btnSendSms"
                                    type="submit"  
                                    :disabled="blockBtn"
                                >
                                    <span v-if="!sendingForm">SEND</span> <span class="fa-1x" v-if="sendingForm"><i class="fas fa-spinner fa-spin redColor"></i></span>
                                </button>
                            </div>
                            <div class="field-confirm">
                                <label>
                                    <input 
                                        type="checkbox" 
                                        id="cbox1" 
                                        value="confirm"
                                        :disabled="requeresInputs"
                                        v-model="check_confirm"
                                    > I confirm the above message is correct
                                </label><br>
                         
                            </div>
                            <br>
                            <br>
                            
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TopBar from '../../components/TopBar.vue'
import MainMenu from '../../components/MainMenu.vue'
import Logo from '../../components/Logo'
import axios from "axios";

export default {
    props:['templates_data'],
    components: {
        TopBar,
        MainMenu,
        Logo
    },
    data() {
        return {
            custom_content:'',
            phone_number:'',
            check_confirm: false,
            loadingPage: true,
            sendingForm: false
        };
    },
    computed:{
        blockBtn(){
            if (this.custom_content !== "" && this.phone_number !== "" && this.phone_number.length >= 14  && this.check_confirm && !this.sendingForm) { 
                return false 
            }
            else
            { 
                return true
            }
        },

        requeresInputs(){
            
            if (this.custom_content !== "" && this.phone_number !== "") { 
                return false 
            }
            else
            { 
                this.check_confirm = false
                return true
            }
        },
    },
    methods:{
        async sendMsgBox(){
            const self = this;
            self.sendingForm = true;
            //this.custom_content; //this.buildTemplate(this.content, this.variables[0], this.custom_content);
            
            let formData = new FormData();
            formData.append("recipient", this.phone_number.replace(/\D/g, ""));
            formData.append("content", this.custom_content);


            //=================================
            //Get cookie called user_login  
            //=================================  
            /*
            let checkUser = null
            let cname = 'user_login'
            var name = cname + "=";
            var ca = document.cookie.split(";");
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == " ") {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    checkUser = c.substring(name.length, c.length);
                }
            }

            let dataUser = JSON.parse(checkUser)
            */
            axios({
                method: "post",
                url: `https://www.miltoolsms.ca/api/v1/messages`,
                responseType: "json",
                data: formData,
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: "Bearer " + localStorage.getItem('token')//dataUser.data.jwt
                }
            })
            .then(function(response) {
                if (response.data) {
                    self.callToast(`Thank you. Your message was successfully sent!`, 'success')
                    self.custom_content = ''
                    self.phone_number = ''
                    self.check_confirm = false
                }else{
                    self.callToast(`There was an error`, 'warning')
                }

                self.sendingForm = false
            })
            .catch(error => (self.callToast(`There was an error: ${error}`, 'warning'), (self.sendingForm = false)));   
        },

        callToast(message, status){
            this.$toast.show(message, {
                type: status,
                position: 'top-right'
                // all of other options may go here
            });
        },
    }
}
</script>

<style>

</style>